import Routines from "./routines";

export default [
  // Each object is a day
  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },

  {
    complete: false,
    length: "30 min",
    locked: true,
    routines: Routines.week3day1,
    title: "Basic Core Strength III",
  },
];
